//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  data:function() {
    let beginTime = this.$route.query.beginTime || moment().format('YYYY-MM-DD');
    let endTime = this.$route.query.endTime || moment().format('YYYY-MM-DD');
    return {
      search: {
        beginTime: beginTime,
        endTime: endTime,
        sortBy: 'sortByAmount'
      },
      sortOptions: [
        {value: 'sortByAmount', label: '销售金额'},
        {value: 'sortByCount', label: '销售数量'}
      ],
      table: [],
      page: {
        pageNo: 1,
        pageSize: 20,
        total: 0
      },
      loading: false
    }
  },
  components: {
    PageHeader: () => import('./components/PageHeader/index.vue'),
    PageMain: () => import('./components/PageMain/index.vue')
  },
  mounted () {
    this.handleLoadTableData()
  },
  methods: {
    handleLoadTableData () {
      return new Promise((resolve, reject) => {
        this.loading = true
        let data = _.extend({}, _.omit(this.search, 'sortBy'), _.pick(this.page, 'pageNo', 'pageSize'))
        data[this.search.sortBy] = 1
        // console.log('data', data)
        this.$axios.get('/mtea/store/admin/report/goodsStatistics', { params: data }).then(res => {
          this.page.total = res.total
          this.table = res.records
        }).finally(() => {
          this.loading = false
          resolve()
        })
      })
    }
  }
}
